import { useMemo, useRef } from 'react';
import { useHoverDirty } from 'react-use';
import { Content } from 'src/contexts/ContentContext';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';
import { Tooltip } from 'src/core/ui';
import { PosIconProps } from 'src/svgs/SvgWrapper';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './EventHeader.css';

export const EventHeaderIconWithHoverEffect = ({
  IconComponent,
  useStroke,
  selected,
  contentId,
  ...props
}: Omit<PosIconProps, 'viewBox'> & {
  contentId: ContentId;
  IconComponent: React.ComponentType<Omit<PosIconProps, 'viewBox'>>;
  useStroke?: boolean;
  selected?: boolean;
}) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const isHovering = useHoverDirty(elementRef);
  const { isDarkMode } = useSiteTheme();

  const iconColor = useMemo(() => {
    if (selected) {
      return vars.color.textInverted;
    }
    if (isHovering) {
      return vars.color.textBrand;
    }
    return vars.color.textPrimary;
  }, [isHovering, selected]);

  return (
    <Tooltip
      open={isHovering}
      delayDuration={100}
      triggerContent={
        <div className={styles.toggleGroupItem} ref={elementRef}>
          <IconComponent
            {...props}
            fill={!useStroke ? iconColor : undefined}
            stroke={useStroke ? iconColor : undefined}
          />
        </div>
      }
      contentVariant={isDarkMode ? 'light' : 'dark'}
      align="center"
    >
      <Content id={contentId} />
    </Tooltip>
  );
};
